module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/za06bN/tc-custom/9781646566570.jpg?1723406086135",
      "alt": "This image is the cover for the book Penance"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Penance\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('i', [_vm._v("Bound by misery. Marked by sin. Set free by death.")]), _c('br'), _c('br'), _vm._v("Barely into their teens, without homes, they dwell in neon shadows, the violent eddies of urban America. They trade their innocence for money, abuse their hopes, and then a monster comes ..."), _c('br'), _c('br'), _vm._v("A monster without fangs or claws, but more deadly. Because of them, he has lost everything: his wife, his family. And he vows to clean the streets of Chicago ... for good."), _c('br'), _c('br'), _vm._v("One of the street kids and a man of the cloth form a desperate pact. Together, they will find the madman whose basement has become a chamber of horrors ...\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Rick R. Reed\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4b7db194","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0